import React, { useState, useReducer } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import {
} from '@mui/material';

import CustomBackdrop from '../../../../../../components/CustomBackdrop';
import { stationReducer } from '../Common';
import Steps from '../Common/components/Steps';

import { createStation } from './mutations';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>,
  organisation_id?: string,
  area_id?: string,
  section_id: string,
  handleFinish: (id: string) => void,
}

const CreateStation = ({ classes, history, organisation_id, area_id, section_id, handleFinish }: Props): React.ReactElement => {
  
  const [station, dispatchStation] = useReducer(stationReducer, {
    name: '',
    phone: '',
  });

  const [saving, setSaving] = useState<boolean>(false);

  const handleSave = async () => {
    setSaving(true);

    const insertVariables = {
      object: {
        ...station,
        organisation_id,
        area_id,
        section_id,
      },
    };
    const station_id: string | undefined = await createStation(insertVariables);

    if (station_id) {
      setSaving(false);
      handleFinish(station_id);
    }
  };

  return (
    <>
      <Steps
        completeLabel="Create"
        station={station}
        dispatch={dispatchStation}
        handleSave={handleSave} />
      {saving && <CustomBackdrop label="Creating Station" />}
    </>
  );
};

export default withRouter(withStyles(styles)(CreateStation));
